import { StructuredRelatedCompanyDto } from "@green0meter/api-client";
import { Edge, Node } from "@xyflow/react";

import { DEFAULT_POSITION, EDGE_TYPE } from "./OrgChart.constants";

export const calculateDiagramNodes = (
  data: StructuredRelatedCompanyDto,
  currentNodes: Node[],
): Node[] => {
  const oldNodes: Record<string, Node> = {};

  for (const node of currentNodes) {
    oldNodes[node.id] = node;
  }
  const nodes: Node[] = [];

  const processCompany = (company: StructuredRelatedCompanyDto): void => {
    nodes.push({
      id: company.id,
      type: "companyNode",
      data: {
        name: company.name,
      },
      position: oldNodes[company.id]?.position ?? DEFAULT_POSITION,
    });

    if (company.childCompanies && company.childCompanies.length > 0) {
      company.childCompanies.forEach((childCompany) => {
        processCompany(childCompany);
      });
    }
  };

  processCompany(data);

  return nodes;
};

export const calculateDiagramEdges = (data: StructuredRelatedCompanyDto): Edge[] => {
  const edges: Edge[] = [];

  const processCompany = (company: StructuredRelatedCompanyDto): void => {
    if (company.childCompanies && company.childCompanies.length > 0) {
      company.childCompanies.forEach((childCompany) => {
        edges.push({
          id: `e${company.id}-${childCompany.id}`,
          source: company.id,
          target: childCompany.id,
          type: EDGE_TYPE,
          animated: false,
        });
        processCompany(childCompany);
      });
    }
  };

  processCompany(data);

  return edges;
};
